import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import { getBenefisCategoryAll } from "../../../BenefisCategory/_redux/benefisCategory/benefisCategoryCrud";
import {
  validateDataInd as validateUpload,
  saveBenefisDataIndividu
} from "../../_redux/benefis/benefisCrud";
import { toast } from "react-toastify";
import BenefisImportTable from "./BenefisImportTable";
import BenefisInvalidTable from "./BenefisInvalidTable";
import Loading from "../../../../../_metronic/layout/components/loading/Loading";
import ModalEditBenefis from "./ModalEditBenefis";

export const BenefisImportIndividual = ({
  history,
  match: {
    params: { type, id }
  }
}) => {
  const [uploadData, setUploadData] = useState([]);
  const [successData, setSuccessData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [isValidation, setIsValidation] = useState(true);
  const [openEditBenefis, setOpenEditBenefis] = useState({
    show: false,
    initValues: {}
  });
  const [isStart, setIsStart] = useState(true);
  const [loading, setLoading] = useState({
    show: false,
    percentage: 0
  });

  const validateData = async () => {
    let dataSuccess = [];
    let dataError = [];

    setIsStart(false);

    try {
      if (successData.length === 0) {
        for (let i = 0; i < uploadData.length; i++) {
          await validateUpload(uploadData[i]).then(({ data }) => {
            let newErrors = {
              ...data.errors
            };
            let emailExist = dataSuccess.find(i => i.email === data.data.email);
            let hpExist = dataSuccess.find(i => i.hp === data.data.hp);
            let nikExist = dataSuccess.find(i => i.nik === data.data.nik);

            if (emailExist || hpExist || nikExist) {
              newErrors = {
                ...data.errors,
                emailExist: emailExist
                  ? "Terdapat duplikasi email pada data yang diupload"
                  : "",
                hpExist: hpExist
                  ? "Terdapat duplikasi nomor hp pada data yang diupload"
                  : "",
                nikExist: nikExist
                  ? "Terdapat duplikasi nomor KTP pada data yang diupload"
                  : ""
              };
            }

            if (Object.keys(newErrors).length > 0) {
              dataError.push({
                data: data.data,
                errors: newErrors
              });
            } else {
              dataSuccess.push(data.data);
            }
            let percentage = Math.round((i / uploadData.length) * 100);
            setLoading({ show: true, percentage: percentage });
          });
        }
      } else {
        for (let i = 0; i < successData.length; i++) {
          await validateUpload(successData[i]).then(({ data }) => {
            let newErrors = {
              ...data.errors
            };

            let emailExist = dataSuccess.find(i => i.email === data.data.email);
            let hpExist = dataSuccess.find(i => i.hp === data.data.hp);
            let nikExist = dataSuccess.find(i => i.nik === data.data.nik);

            if (emailExist || hpExist || nikExist) {
              newErrors = {
                ...data.errors,
                emailExist: emailExist
                  ? "Terdapat duplikasi email pada data yang diupload"
                  : "",
                hpExist: hpExist
                  ? "Terdapat duplikasi nomor hp pada data yang diupload"
                  : "",
                nikExist: nikExist
                  ? "Terdapat duplikasi nomor KTP pada data yang diupload"
                  : ""
              };
            }

            if (Object.keys(newErrors).length > 0) {
              dataError.push({
                data: data.data,
                errors: newErrors
              });
            } else {
              dataSuccess.push(data.data);
            }

            let percentage = Math.round((i / successData.length) * 100);
            setLoading({ show: true, percentage: percentage });
          });
        }
      }

      setErrorData(dataError);
      setSuccessData(dataSuccess);

      if (dataError.length === 0) {
        setIsValidation(false);
      }
    } catch (error) {
      toast.error("Terjadi Kesalahan Silakan Coba kembali");
    } finally {
      setLoading({ show: false, percentage: 0 });
    }
  };

  const getBenefisCategory = async () => {
    try {
      const res = await getBenefisCategoryAll();
      let options = [];
      res.data.data.map((item, index) => {
        options.push({ value: item.uuid, label: item.name });
      });

      return options;
    } catch (error) {
      toast.error("Terjadi Kesalahan");
    }
  };

  const downloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const benefis_category_xlsx = await getBenefisCategory();
    workbook.addWorksheet("import_data");
    workbook.addWorksheet("benefis_category_data");

    const category_data = workbook.getWorksheet("benefis_category_data");
    const worksheet = workbook.getWorksheet("import_data");
    worksheet.columns = [
      { header: "No", key: "no", width: 5 },
      { header: "Nama", key: "name", width: 20 },
      { header: "Telepon", key: "hp", width: 20 },
      { header: "Email", key: "email", width: 30 },
      {
        header: "Kategori Penerima Manfaat",
        key: "benefis_category",
        width: 45
      },
      { header: "Provinsi", key: "province", width: 20 },
      { header: "Kabupaten", key: "city", width: 20 },
      { header: "Kecamatan", key: "district", width: 20 },
      { header: "Kode Pos", key: "postal_code", width: 20 },
      { header: "No KTP", key: "nik", width: 30 },
      { header: "Status Hidup", key: "is_alive", width: 20 },
      { header: "Status Aktif", key: "is_active", width: 20 }
    ];

    benefis_category_xlsx.map(item => {
      category_data.addRow([`${item.label}  -  ${item.value}`]);
    });

    worksheet.dataValidations.add("E2:E1001", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: [
        `=benefis_category_data!$A$1:$A$${benefis_category_xlsx.length}`
      ],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Kategori Penerima Manfaat"
    });

    worksheet.dataValidations.add("K2:K1001", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: ['"Hidup,Meninggal"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Status Hidup"
    });

    worksheet.dataValidations.add("L2:L1001", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: ['"Aktif,Tidak Aktif"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Status Aktif"
    });

    workbook.xlsx.writeBuffer().then(function(buffer) {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `template_import_PM_Individu.xlsx`
      );
    });
  };

  const readXlsxFile = e => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = evt => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      if (
        data[0][0] !== "No" ||
        data[0][1] !== "Nama" ||
        data[0][2] !== "Telepon" ||
        data[0][3] !== "Email" ||
        data[0][4] !== "Kategori Penerima Manfaat" ||
        data[0][5] !== "Provinsi" ||
        data[0][6] !== "Kabupaten" ||
        data[0][7] !== "Kecamatan" ||
        data[0][8] !== "Kode Pos" ||
        data[0][9] !== "No KTP" ||
        data[0][10] !== "Status Hidup" ||
        data[0][11] !== "Status Aktif"
      ) {
        toast.error("Template Tidak Sesuai");
        return;
      }

      let objData = {};
      let arrData = [];

      data.map((item, index) => {
        if (index > 0) {
          objData = {
            name: item[1],
            hp: item[2] ? item[2].toString() : "",
            email: item[3],
            benefis_category: item[4],
            province: item[5],
            city: item[6],
            district: item[7],
            postal_code: item[8],
            nik: item[9],
            is_alive: item[10],
            is_active: item[11],
            benefis_category_uuid: item[4]
              ? item[4].split(" - ")[1].trim()
              : "",
            benefis_category_name: item[4] ? item[4].split(" - ")[0].trim() : ""
          };
          arrData.push(objData);
        }
      });
      setUploadData(arrData);
    };

    reader.readAsBinaryString(file);
  };

  const hideEditBenefis = () => {
    setOpenEditBenefis({
      ...openEditBenefis,
      show: false,
      initValues: {}
    });
  };

  const saveEditedData = value => {
    let newErrorData = errorData.filter(item => item.data.key !== value.key);
    let newSuccessData = [...successData, value];
    setErrorData(newErrorData);
    setSuccessData(newSuccessData);
  };

  const saveFinishedData = () => {
    let arrPromise = [];
    let percentage = 0;
    successData.map(item => {
      arrPromise.push(saveBenefisDataIndividu(item));
    });

    setLoading({ ...loading, show: true });

    Promise.all(arrPromise)
      .then(res => {
        percentage = (res.length / successData.length) * 100;
        setLoading({ ...loading, percentage: percentage });
        toast.success("Data Berhasil Disimpan");
        setUploadData([]);
        setErrorData([]);
        setSuccessData([]);
        history.goBack();
      })
      .catch(err => {
        toast.error("Data Gagal Disimpan");
      })
      .finally(() => {
        setLoading({ ...loading, show: false });
      });
  };

  return (
    <>
      <Loading {...loading} />
      <ModalEditBenefis
        {...openEditBenefis}
        onHide={() => hideEditBenefis()}
        onSubmit={value => {
          saveEditedData(value);
          hideEditBenefis();
        }}
      />
      <Card>
        <CardHeader title="Import Penerima Manfaat Individu">
          <CardHeaderToolbar>
            {RoleChecker("Create", "benefis") && (
              <button
                type="button"
                className="btn btn-outline-primary ml-4"
                onClick={() => {
                  downloadTemplate();
                }}
              >
                Download Template
              </button>
            )}
            <button
              className="btn btn-secondary ml-4"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-lg-2">
              <label>Import Data: </label>
            </div>
            <div className="col-lg-10">
              <input
                type="file"
                accept=".xlsx"
                onChange={e => {
                  readXlsxFile(e);
                }}
              />
            </div>
          </div>
        </CardBody>
      </Card>

      {errorData.length !== 0 && (
        <Card>
          <CardHeader title="Data tidak valid" />
          <CardBody>
            <BenefisInvalidTable
              errorRows={errorData}
              setOpenEditBenefis={setOpenEditBenefis}
            />
          </CardBody>
        </Card>
      )}

      <Card>
        <CardHeader title="Daftar Import">
          <CardHeaderToolbar></CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BenefisImportTable
            dataTable={isStart ? uploadData : successData}
            saveData={() => {
              saveFinishedData();
            }}
            isValidation={isValidation}
            validateData={validateData}
            errorRows={errorData}
          />
        </CardBody>
      </Card>
    </>
  );
};
